import { authConfig } from "../apiConfig";

// PROJECT REPORTS
export const get_project_reports_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`ProjectOverView`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};